<template>
    <div class="category-grid">
        <router-link
      v-for="(category, index) in gameCategory"
      :key="index"
      :to="`/ex-game-category/${encodeData(category.name)}/name`"
      class="category-card"
    >
      <img :src="category.icon" alt="icon" class="category-icon" />
      <span class="category-name">{{ category.name }}</span>
    </router-link>
    </div>
  </template>
  
  <script>
import { encodeData } from '@/utils/utils';

  export default {
    data() {
      return {
        gameCategory: [],
        SITEAUTHKEY: process.env.VUE_APP_API_SITE_AUTH_KEY,
      };
    },
   
    methods: {
        encodeData,
      async getCatgoryList() {
        try {
          const response = await fetch(
            `${process.env.VUE_APP_API_KEY}/api/game-navigation/get-all-game-navigation?site_auth_key=${this.SITEAUTHKEY}`,
            {
              method: 'GET',
            }
          );
  
          if (!response.ok) {
            throw new Error('Something went wrong');
          }
  
          // Parse the response JSON
        const responseData = await response.json();
        this.gameCategory = responseData?.data;
        console.log("getcategiryda", responseData);


        } catch (error) {
          console.error('Error fetching category data:', error);
        }
      },
    },
    mounted() {
      const siteAuthKey = process.env.VUE_APP_API_SITE_AUTH_KEY;
      this.SITEAUTHKEY = siteAuthKey;
      this.getCatgoryList()
    },
  };
  </script>
  
  <style scoped>
  .category-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    padding: 10px;
    margin-bottom: 80px;
  }
  .category-card {
    background:#090909;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;;
    border-radius: 12px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;

  }
  .category-card:hover {
    background-color: rgba(50, 50, 50, 0.95);
  }
  .category-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
  }
  .category-name {
    color: #fff;
    font-size: 14px;
    text-align: center;
  }
  </style>
  